import { render, staticRenderFns } from "./SchoolEmployeeExportLegend.vue?vue&type=template&id=5d786695&scoped=true&"
import script from "./SchoolEmployeeExportLegend.vue?vue&type=script&lang=js&"
export * from "./SchoolEmployeeExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d786695",
  null
  
)

export default component.exports